import React, { Fragment, memo, useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import tw from 'twin.macro'
import {
  getRecollectionActionNeededSteps,
  getRecollectionUnderReviewSteps,
} from 'src/selectors/collectData'
import { SelectRecollectionStep } from 'src/constants/actionTypes'
import { CLIENT_ROUTES } from 'src/constants/routes'
import type { CollectDataStep } from 'src/interfaces/collectData'
import { RecollectionStepCard } from './RecollectionStepCard'
import { RecollectionEmptyState } from './RecollectionEmptyState'

const RecollectionActionListComponent = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const actionNeededSteps = useSelector(getRecollectionActionNeededSteps)
  const underReviewSteps = useSelector(getRecollectionUnderReviewSteps)

  useEffect(() => {
    dispatch(SelectRecollectionStep.success(null))
  }, [dispatch])

  const handleSelectStep = useCallback(
    (step: CollectDataStep) => {
      return () => {
        dispatch(SelectRecollectionStep.success(step.id))
        navigate(CLIENT_ROUTES.DOCS_URL)
      }
    },
    [dispatch, navigate],
  )

  if (!actionNeededSteps.length && !underReviewSteps.length) {
    return <RecollectionEmptyState />
  }

  return (
    <div css={tw`flex flex-col w-full`}>
      {!!actionNeededSteps.length && (
        <Fragment>
          <Typography variant="overline" css={tw`mt-4 mb-2 text-shades-400`}>
            ACTION NEEDED
          </Typography>
          {actionNeededSteps.map((step) => {
            return (
              <RecollectionStepCard
                key={step.id}
                step={step}
                variant="actionNeeded"
                onClick={handleSelectStep(step)}
              />
            )
          })}
        </Fragment>
      )}
      {!!underReviewSteps.length && (
        <Fragment>
          <Typography variant="overline" css={tw`mt-4 mb-2 text-shades-400`}>
            UNDER REVIEW
          </Typography>
          {underReviewSteps.map((step) => {
            return <RecollectionStepCard key={step.id} step={step} variant="underReview" />
          })}
        </Fragment>
      )}
    </div>
  )
}

export const RecollectionActionList = memo(RecollectionActionListComponent)
